import { Reveal } from "@/components/Reveal";
import { FeedList } from "@/components/FeedList";

export default function Feed() {
  return (
    <div className="min-h-screen bg-bone pt-32 pb-24">
      <div className="max-w-[720px] mx-auto px-6 md:px-10">
        <Reveal>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-black">The Brotherhood</span>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4">Community Feed</h1>
          <p className="font-sans text-charcoal/60 mt-4">Share updates, praises, and encouragement with the brothers.</p>
        </Reveal>
        <div className="mt-10">
          <FeedList />
        </div>
      </div>
    </div>
  );
}
